import React, { useRef, useState, useEffect } from "react";
import { Avatar, SelectPicker, Uploader, Progress, Button, Placeholder, Whisper, Tooltip, Popover } from "rsuite";
import "rsuite/SelectPicker/styles/index.css";
import Logo from "../images/logo.svg";
import Sidebar from "../component/Sidebar";
import { CircleFlag } from "react-circle-flags";
import { encryptData, decryptData } from "./cryptoUtil";
import { ChakraProvider, useToast, Wrap, extendTheme } from "@chakra-ui/react";
import { Block } from "@mui/icons-material";
import { Navigate, useNavigate } from 'react-router-dom';

const ReassignmentManagement = () => {

  const theme = extendTheme({
  config: {
    disableGlobalStyles: true,
  },
});

  const [tabName, setTabName] = useState("Country Assignment");
  useEffect(() => {
    document.title = tabName;
  }, [tabName]);

  const whisperRef = useRef();

    const userid = sessionStorage.getItem("userId");
    const isAdmin = sessionStorage.getItem("isAdmin");
    const navigate = useNavigate();
    useEffect(() => {
    if (isAdmin == 1) {
      navigate('/'); // ya homepage, etc.
    }
  }, [isAdmin]);



    const apiEndPoint = process.env.REACT_APP_API_ENDPOINT;
    const [isLoading, setLoading] = useState(false); // State to manage loading state
    const [selectedInvestorId, setSelectedInvestorId] = useState();
    const [assignUserComment, setAssignUserComment] = useState("");
    const [refreshKey, setRefreshKey] = useState(0);
    const [assignUserid, setAssignUserid] = useState("");
    const [userData, setUserData] = useState([]);
    const [currentUser, setCurrentUser] = useState(null);
    const [combinedCountries, setCombinedCountries] = useState([]);
    const [existingCountries, setExistingCountries] = useState([]);
    const [newAssignCountries, setNewAssignCountries] = useState([]);
    const [globalLoading, setGlobalLoading] = useState(true); // State to manage loading state
    const abortControllerRefGlobal = useRef(null);
    const [reportdata, setReportData] = useState([]);
    const [reportCount, setReportCount] = useState(0);
    const [userStatus, setUserStatus] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [isDeleteLoading, setDeleteLoading] = useState(false); // State to manage loading state
    const [selectedId, setSelectedId] = useState(null);
    const [openStatusPopover, setOpenStatusPopover] = useState(null);

      const [confirmLoading, setConfirmLoading] = useState(false); 

    const toast = useToast();
    const toastIdRef = React.useRef();

  const [toggled, setToggled] = useState(false);
  // const [ipo, setIpo] = useState(0);

const handleToggle = () => {
  //setUserStatus(!userStatus); // true becomes false, false becomes true
    if (userStatus) {
    } else {
      toastIdRef.current = toast({ description: "You can't go offline directly please assign a temporary user for your countries before proceeding.", status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
    }
};

  const AssignSalesPerson = [
    { label: "Mohammad Akmal", value: "SP001" },
    { label: "Ayesha Khan", value: "SP002" },
    { label: "Omar Farooq", value: "SP003" },
    { label: "Fatima Ali", value: "SP004" },
    { label: "Zaid Rahman", value: "SP005" },
  ];

  const [AssignSalesPersonCode, setAssignSalesPersonCode] = useState(null);
  const handleAssignSalesPersonChange = (value) => {
    setAssignSalesPersonCode(value);
  };


  const fetchGlobalReport = async () => {
 
      setGlobalLoading(true);
  
      // Cancel the previous request if any
      if (abortControllerRefGlobal.current) {
        abortControllerRefGlobal.current.abort();
      }
  
      const controller = new AbortController();
      abortControllerRefGlobal.current = controller;
  

  
      try {
      
        const apiUrl = `${apiEndPoint}/get_offline_user_history`;
        const requestData = encryptData({
          data: {
            user_id: userid
          },
        });
  
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: requestData,
          signal: controller.signal,
        });
  
        const jsonData = await response.json();
        const decrypted = decryptData(jsonData);
  
        if (decrypted.status == "success") {
          setGlobalLoading(false);
          setReportCount(decrypted.count);
          setReportData(decrypted.data);
        } else {
          setGlobalLoading(false);
          setReportCount(decrypted.count);
          setReportData(decrypted.data);
          // toastIdRef.current = toast({ description: decrypted.message, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
          return false;
        }
      } catch (error) {
        if (error.name === "AbortError") {
          console.log("GLobal Request cancelled");
        } else {
          setGlobalLoading(false);
          toastIdRef.current = toast({ description: error.message, status: "success", duration: 5000, isClosable: true, position: "bottom", });
        }
        return false;
      }
    };

      useEffect(() => { fetchGlobalReport(); }, [refreshKey]); // Regular effect for other dependencies

   

//  const handleUserChange = (selectedUserId) => {
//   setAssignUserid(selectedUserId);

//   const selectedUser = userData.find(user => user.value === selectedUserId);
//   const selectedCountries = selectedUser?.countries || [];
//   const currentCountries = currentUser?.countries || [];

//   const combined = [...currentCountries, ...selectedCountries];
//   const uniqueCountries = Array.from(
//     new Map(combined.map(c => [c.country_code, c])).values()
//   );

//   setCombinedCountries(uniqueCountries); // Store for rendering
// };

const handleUserChange = (selectedUserId) => {
 
  if (selectedUserId === null) {
    // Cross icon clicked: Clear selection
    setAssignUserid(null);
    setExistingCountries([]);
    setNewAssignCountries([]);
    console.log("Selection cleared"); // Or call your custom function here
    return;
  }
  else{
    setAssignUserid(selectedUserId);
  }
  
  const existingUser = userData.find(user => user.value == selectedUserId);
  const existingCountries = existingUser?.countries || [];

  
  const newCountries = currentUser?.countries || [];

  // Store existing countries separately
  console.log('Existing : '+  selectedUserId + ': '+ JSON.stringify(existingCountries));
  setExistingCountries(existingCountries);

  // Store new assigned countries separately
   console.log('New : '+  userid + ': '+ JSON.stringify(newCountries));
  setNewAssignCountries(newCountries);
};

   useEffect(() => {
      const fetchCountryList = async () => {
        const url = `${apiEndPoint}/sales_users`;
        const payload = encryptData({
          data: {
            user_id: userid, // Replace with the actual user_id if dynamic
          },
        });
  
        try {
          const response = await fetch(url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: payload,
          });
  
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
  
          const responseData = await response.json();
          const data = decryptData(responseData); // Flatten the response

          const { current_user, users } = data.data;
          setUserStatus(current_user.is_offline);
          setCurrentUser(current_user);
            const formattedUserData = users.map((user) => ({
                label: user.fullname,
                value: user.id,
                profile_img: user.profile_img,
                countries: user.countries || [],
            }));  
  
          setUserData(formattedUserData);
        } catch (error) {
          //setErrorMessage(error.message);
          //setMessageType("error");
          return false;
        }
      };
  
      fetchCountryList();
    }, []);


   


    const handleReassignSave = async () => {

       if (assignUserid === null) {
          toastIdRef.current = toast({ description: "Please Select IR User", status: "error", duration: 5000, isClosable: true, position: "bottom", });
          return false;
        }

    
        try {
          setLoading(true);
          const apiUrl = `${apiEndPoint}/reassign_offline_user_work`;
          const requestData = encryptData({
            data: {
              offline_user_id: userid,
              assign_to_id: assignUserid,
              comment: assignUserComment,
            },
          });
    
          const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: requestData,
          });
    
          const jsonData = await response.json();
          const decrypted = decryptData(jsonData);
    
          if (decrypted.status == "success") {
            setLoading(false);
            setRefreshKey((prev) => prev + 1);
            setUserStatus(decrypted.is_offline);
              setAssignUserid("");
              setExistingCountries([]);
              setNewAssignCountries([]);
              setAssignUserComment("");
            setShowModal(false);
            toastIdRef.current = toast({ description: decrypted.message, status: "success", duration: 5000, isClosable: true, position: "bottom", });
          } else {
            setLoading(false);
            toastIdRef.current = toast({ description: decrypted.message, status: "error", duration: 5000, isClosable: true, position: "bottom", });
            return false;
          }
        } catch (error) {
          setLoading(false);
          toastIdRef.current = toast({ description: error.message, status: "error", duration: 5000, isClosable: true, position: "bottom", });
          return false;
        }
      };


       const handleDeleteCancel = () => {
        setShowModal(false);
    };



      const openDeleteModal = () => {
        setShowModal(true);
      };

  const handlePublishConfirm = async () => {
      try {
          setConfirmLoading(true);
          const apiUrl = `${apiEndPoint}/reset_offline_user`;
          const requestData = encryptData({
            data: {
              user_id: userid,
            },
          });
    
          const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: requestData,
          });
    
          const jsonData = await response.json();
          const decrypted = decryptData(jsonData);

          console.log(decrypted.is_offline);
    
          if (decrypted.status == "success") {
            setConfirmLoading(false);
            setRefreshKey((prev) => prev + 1);
            setUserStatus(decrypted.is_offline);
            whisperRef.current?.close();
            toastIdRef.current = toast({ description: decrypted.message, status: "success", duration: 5000, isClosable: true, position: "bottom", });
          } else {
            setConfirmLoading(false);
            
            toastIdRef.current = toast({ description: decrypted.message, status: "error", duration: 5000, isClosable: true, position: "bottom", });
            return false;
          }
        } catch (error) {
          setConfirmLoading(false);
          toastIdRef.current = toast({ description: error.message, status: "error", duration: 5000, isClosable: true, position: "bottom", });
          return false;
        }
  
    
  };

     const handleConfirm = () => {
    setUserStatus(!userStatus);
  };

  const handleCancel = () => {
    setAssignUserid("");
    setExistingCountries([]);
    setNewAssignCountries([]);
    setAssignUserComment("");
  };
  
 

   const renderPopover = (
     <Popover className=" " preventOverflow>
                        <div className="tooltip_form_inner text-center">
                            <div style={{ fontSize: 20, color: "#141B3C", fontWeight: 600, lineHeight: 1.3 }}>
                                Coming online will restore your <br /> assigned countries. Confirm to continue. 
                                {/* {company.report_status ? 'deactivate' : 'activate'} company? */}
                            </div>

                            <div className='btn__group mt-5'>
                                <a href="#" className='btn__cancel' onClick={() => whisperRef.current?.close()}>Cancel</a>
                                <Button href="#" className='btn__assign' onClick={() => handlePublishConfirm()} loading={confirmLoading}>Confirm</Button>
                            </div>
                        </div>
                    </Popover>
  );

 

    


  return (
    <>
      <Sidebar />
            <ChakraProvider resetCSS={false}>
              <Wrap></Wrap>
            </ChakraProvider>
      <div id="header">
        <div className="logo">
          <div className="logo_icon">
            <img src={Logo} alt="Logo" />
          </div>
          <div className="brand_name">Country Assignment</div>
        </div>

        <div className="header_table_filter">
          <div className="go_offline_toggle">
            <h5>Going Offline</h5>
             <Whisper ref={whisperRef} trigger={userStatus ? "click" : null} placement="auto" speaker={renderPopover}>
         <button className={`toggle-btn ${userStatus  ? "toggled" : ""}`}  onClick={handleToggle} >
              <div className="thumb"></div>
            </button>
        </Whisper>

           
          </div>
        </div>
      </div>

      <div className="container-fluid content pb-4">
        <div
          className="company_details_form"
          style={{ paddingBottom: 0, paddingLeft: 0, paddingRight: 0 }}
        >
          <h2 style={{ paddingLeft: 20, paddingRight: 20 }}>
            {/* Assign Offline Salesperson's Leads */}
            Assign My Leads While Away
          </h2>

          <div
            className="form_details_group mt-3"
            style={{ marginLeft: 20, marginRight: 20 }}
          >
            <div className="row">
              <div className="col-sm-6 col-lg-3">
                <label className="label_form">Assign to Sales Person</label>
                <div className="form_select_drop">
                  <SelectPicker
                    data={userData}
                    searchable={true}
                    style={{ width: "100%" }}
                    placeholder="Select IR User"
                    onChange={handleUserChange}
                    value={assignUserid}
                    renderMenuItem={(label, item) => (
                      <div style={{ display: "flex", alignItems: "center", gap: "10px", }} >
                        <Avatar circle src={item.profile_img} style={{ width: 30, height: 30 }} />
                        <span>{label}</span>
                      </div>
                    )}
                  />
                  {/* <SelectPicker
                                        data={AssignSalesPerson}
                                        searchable={false}
                                        style={{ width: '100%' }}
                                        placeholder="Select an Assignee"
                                        onChange={handleAssignSalesPersonChange}
                                        value={AssignSalesPersonCode}
                                    /> */}
                </div>
              </div>

              {existingCountries.length > 0 && (
              <div className=" col-lg-2">
               
                <label className="label_form">Selected User Current Countries </label>
                
                <ul className="country__check__flags">
                     {existingCountries.map((country, index) => (
    <li key={country.country_code}>
      <div className="form-check">
        <input className="form-check-input" type="checkbox" id={`Check_${index}`} checked />
        <label className="form-check-label" htmlFor={`Check_${index}`}>
          <div className="clogo">
            <CircleFlag
              countryCode={country.country_code.toLowerCase()}
              style={{ width: 24, height: 24 }}
            />
          </div>
          <h6>{country.country_name}</h6>
        </label>
      </div>
    </li>
  ))}

                

                  
                </ul>
              </div>
               )}
  {newAssignCountries.length > 0 && (
                <div className=" col-lg-2">
               
                <label className="label_form">Your Countries to Assign</label>
                 
                <ul className="country__check__flags">
                     {newAssignCountries.map((country, index) => (
    <li key={country.country_code}>
      <div className="form-check">
        <input className="form-check-input" type="checkbox" id={`Check_${index}`} checked />
        <label className="form-check-label" htmlFor={`Check_${index}`}>
          <div className="clogo">
            <CircleFlag
              countryCode={country.country_code.toLowerCase()}
              style={{ width: 24, height: 24 }}
            />
          </div>
          <h6>{country.country_name}</h6>
        </label>
      </div>
    </li>
  ))}

                  

                  
                </ul>
              </div>
)}
              <div className={`col-lg-${existingCountries?.length && newAssignCountries?.length ? 5 : (existingCountries?.length || newAssignCountries?.length ? 7 : 9)}`}>

                <label className="label_form">Notes/Comments (Optional)</label>
                <textarea
                  rows={6}
                  className="form-control"
                  placeholder="Add Any Additional context or instructions here..."
                  value={assignUserComment}
                    onChange={(e) => setAssignUserComment(e.target.value)}></textarea>
              </div>

            </div>
          </div>


          <div className="add_new_btn_group mt-3">
            <button className="btn_cancel_form" onClick={handleCancel}>Cancel</button>
            <button className="btn_save_form"  onClick={() => openDeleteModal()} style={{width:180}}>Delegate Access</button>
            {/*  */}
          </div>
        </div>

        <div className="recent_reassignment_table mt-4">
          <div className="recent_reassignment_table_title_row">
            <h5>Recent Reassignments</h5>
          </div>
          {globalLoading && ( <Placeholder.Grid rows={20} columns={9} active style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 12 }} /> )}
           {!globalLoading && (
          <>
          <div className="company_table_list">
            <div className="table-responsive" style={{ paddingBottom: 0 }}>
              <table className="table">
                <thead>
                  <tr>
                    <th>Offline Person</th>
                    <th>Assigned To</th>
                    <th>Country</th>
                    <th>Status</th>
                    <th>Reason</th>
                    <th style={{ textAlign: "center" }}>Effective Date</th>
                  </tr>
                </thead>
                <tbody>
                      {reportdata && reportdata.length === 0 ? (
                      <tr>
                        <td colSpan="14" style={{ textAlign: "center", fontSize: 20, paddingTop: 60, paddingBottom: 30, }} >
                          No data available
                        </td>
                      </tr>
                    ) : (
                        reportdata &&
                      reportdata.map((item, index) => (
                        <>
                  <tr>
                    <td style={{ fontWeight: 500, fontSize: 14, color: "#000" }}> {item.fullname} </td>
                    <td style={{ fontWeight: 500, fontSize: 14, color: "#000" }}> {item.assign_to_name} </td>
                    <td style={{ fontWeight: 500, fontSize: 14, color: "#000" }}> 
                        <div style={{display:'flex', alignItems:'center', flexWrap:'wrap',maxWidth:160,gap: '5px 0px' }}>
                          {item.countries.map((country, index) => (
                                <CircleFlag key={index} countryCode={country.code.toLowerCase()} style={{ width: 24, height: 24, marginRight: 6 }} />
                        ))}
                           </div>
                    </td>
                    <td style={{ fontWeight: 500, fontSize: 14, color: "#000" }}> {item.type} </td>
                    <td style={{ fontWeight: 500, fontSize: 14, color: "#000" }}> {item.comment} </td>
                    <td style={{ fontWeight: 500, fontSize: 14, color: "#000", textAlign: "center", }} > {item.created_at} </td>
                  </tr>
                   </>
                      ))
                    )}
               
                </tbody>
              </table>
            </div>
          </div>
          </>
           )}
        </div>
      </div>

       {showModal && (
           <div className={`modal fade report_delete_modals ${showModal ? "show d-block" : ""}`}  tabindex="-1" aria-labelledby="deleteModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-body">
                           <h5>Are you sure you want to temporarily hand over<br />access to the selected countries?</h5>
                            <p>This action will temporarily transfer access rights.<br />The selected countries will be accessible to the new user<br />until the current user goes back online.</p>
                            <div class="btn__group mt-5" style={{}}>
                                <button type="button" className="btn__cancel" onClick={handleDeleteCancel}>Cancel</button>
                                <Button type="button" className="btn__assign" onClick={handleReassignSave} loading={isLoading}>Confirm</Button>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            )}

    </>
  );
};

export default ReassignmentManagement;
